import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SseNotificationService {

    constructor() { }

	public static checkForSystemUpdate(): Date | null {
		let updateTimer = localStorage.getItem('update-timer');

		if (
			!updateTimer 
			|| new Date(JSON.parse(updateTimer)) < new Date()
		) {
			localStorage.removeItem('update-timer');
			return null;
		}

		return new Date(JSON.parse(updateTimer));
	}
}
